const path = `examineeprofiles`;

export const state = {
};

export const getters = {
};

export const mutations = {
};

export const actions = {
	[`getAllSimple`]() {
		return new Promise((resolve, reject) => {
			this._vm.$http.get(`/${path}`)
			.then((response) => {
				response.data = response.data || []
				const simpleData = response.data.map(client =>{
					return { 
						id: client.id,
						credits: client.credits,
						username : client.user.username
					}
				})
				resolve(simpleData);
			})
			.catch(reject)
		});
	},

	getStatus(store, { id }) {
		return this._vm.$http.get(`/${path}/${id}/status`)
			.then(response => response.data ? response.data.status : null);
	},

	consumeCredit(store, { id }) {
		return this._vm.$http.get(`/${path}/${id}/consumeCredit`)
			.then(response => response.data ? response.data.status : null);
	},
	getAllFlat(store, data) {
		return this._vm.$http.post(`/${path}/flat`, data)
		.then(response => {
			
			var flattenArray = response.data.map(examinee =>{
				examinee.username = examinee.user.username;
				examinee.createdAt = examinee.user.createdAt;
				examinee.user = null
				delete examinee.user;
				delete examinee.userId;
				delete examinee.clientProfileId;

				for(var key in examinee){
					if(!examinee[key])
					examinee[key] = ''
				}
				return examinee
			})
			return { data : flattenArray }
		})
	},


	// --- Generic Methods
	[`fields`]() {
		return this._vm.$http.get(`/${path}/fields`);
	},
	[`getAll`]() {
		return this._vm.$http.get(`/${path}`);
	},
	[`getAllOfClient`](store, {clientId}) {
		return this._vm.$http.get(`/${path}/ofclient/${clientId}`);
	},
	[`getAllOfClientSimple`](store, {clientId}) {
		return this._vm.$http.get(`/${path}/ofclientsimple/${clientId}`);
	},
	[`getAllOfClientCsv`](store, {clientId}) {
		return this._vm.$http.get(`/${path}/ofclientcsv/${clientId}`);
	},
	[`get`](store, { id }) {
		return this._vm.$http.get(`/${path}/${id}`);
	},
	[`getFull`](store, { id }) {
		return this._vm.$http.get(`/${path}/full/${id}`);
	},
	[`create`](store, data) {
		return this._vm.$http.post(`/${path}`, data);
	},
	[`update`](store, { id, data }) {
		return this._vm.$http.put(`/${path}/${id}`, data);
	},
	[`delete`](store, { id }) {
		return this._vm.$http.delete(`/${path}/${id}`);
	},
	[`deleteAll`]() {
		return this._vm.$http.delete(`/${path}`);
	},
};
